// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2OA9W","carWrapper":"_1ZfbR","carNames":"_3Ixsz","carText":"_3SlJK","driveAwayWrap":"_21LVF","driveAway":"_27_49"};